// app/javascript/compcalc/components/PVCalc.jsx

import React from "react";
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

import EditIcon from '@material-ui/icons/Edit';
import MenuIcon from '@material-ui/icons/Menu';

import moment from "moment";

import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker as DatePicker } from '@material-ui/pickers';

import withErrorHandling from './ErrorHandling';
import { currencyFormatter, formatShortDate, formatPrintDate, formatLongDate, isValidDate, saveAsFile, sendMail } from '../utils';

import TempDisabilityEarningsDialog from './dialogs/TempDisabilityEarningsDialog';


const styles = theme => ({
  root: {
    // flexGrow: 1,
    marginTop: theme.spacing(1),
  },
  marginBottom: {
    marginBottom: theme.spacing(1),
  },
  inputLabel: {
    fontSize: 20,
    // fontWeight: 'bold',
    // marginBottom: 1*theme.spacing(1), // TODO: margin not working.
  },
  dateField: {
    width: 150,
  },
  group: {
    display: 'flex',
    flexFlow: 'row nowrap',
  },
  listItem: {
    // height: '80% !important',
  },
  textFieldDense: {
    margin: 0,
  },
  alignCenter: {
    // background: 'green',
    display: 'flex',
    justifyContent: 'center',    // Horizontal align.
    alignItems: 'center',        // Vertical align.
  },
  alignLeft: {
    // background: 'blue',
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',        // Vertical align.
  },
  alignRight: {
    // background: 'red',
    display: 'flex',
    flexFlow: 'row-reverse nowrap',
    alignItems: 'center',
  },
  wrapContent: {
    padding: theme.spacing(2),
    display: 'inline-block',
  },
  wrapContent1: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: 2,
    display: 'inline-block',
  },
  pre: {
    width: '100%',
    maxWidth: '800px',
    whiteSpace: 'pre-wrap',
  }
});


class PVCalc extends React.PureComponent {

  constructor(props) {
    super(props);

    this.itemsWPI = [];
    for (let i = 70; i <= 100; ++i)
      this.itemsWPI.push(<MenuItem dense key={ 'percent' + i } value={ i }>{ i }%</MenuItem>);

    this.itemsAge = [];
    for (let i = 1; i < 100; ++i)
      this.itemsAge.push(<MenuItem dense key={ 'age' + i } value={ i }>{ i }</MenuItem>);
    this.itemsAge.push(<MenuItem dense key={ 'age100' } value={ 100 }>100 and over</MenuItem>);

    this.itemsLeTable = [];
    this.itemsLeTable.push(<MenuItem dense key={ 'le2008' } value={ 2008 }>2008</MenuItem>);
    this.itemsLeTable.push(<MenuItem dense key={ 'le2010' } value={ 2010 }>2010</MenuItem>);

    this.itemsDiscount = [];
    for (let i = 0; i <= 15*4; ++i) {
      let f = parseFloat(i) / 4.0;
      this.itemsDiscount.push(
        <MenuItem dense key={ 'discount' + i } value={ i }>{ f }%</MenuItem>
      );
    }

    this.compounds = [ 'Annually', 'Semi-annually', 'Quaterly', 'Monthly' ];
    this.itemsCompound = [];
    for (let i = 0; i < this.compounds.length; ++i) {
      this.itemsCompound.push(
        <MenuItem dense key={ 'compound' + i } value={ i }>{ this.compounds[i] }</MenuItem>
      );
    }

    this.pvOfPDText = 'Present Value of PD';
    this.fvOfPDText = 'Future Value of PD';
    this.pvOfPDText100 = 'Present Value / COLA';
    this.fvOfPDText100 = 'Future Value';

    this.minDOI = new Date('1996-01-01T12:00');
    this.maxDOI = new Date('2024-12-31T12:00');

    let initDOI = new Date('2015-01-01T12:00');

    this.initialState = {
      doi: initDOI,
      wpi: 70,
      age: 50,
      leTable: 2010,
      gender: 0,

      cola: 16,
      discount: 4,
      compound: 0,

      inputAww: false,

      pdRateText: 'PD Rate (maximum)',
      pvOfPDText: this.pvOfPDText,
      fvOfPDText: this.fvOfPDText,

      aww: currencyFormatter.format(0),
      pdRate: currencyFormatter.format(0),

      isManualAww: false,
      awwArray: [],
      awwDialogArray: [],
      isDialogOpen: false,

      isFull: true,

      fvOfPD: 0.0,
      fvOfLP: 0.0,
      fvTotal: 0.0,

      pvOfPD: 0.0,
      pvOfLP: 0.0,
      pvTotal: 0.0,

      yearsPD: 0,
      yearsLP: 0,
      yearsTotal: 0,
    };
    this.state = { ...this.initialState };
  }

  componentDidMount = () => {
    this.props.setChildMenuHandler(this.handleMenu);
    this.calculate();
  }

  // --------------------- Selection changed events ---------------------
  onDialogOpen = () => {
    this.setState({
      awwDialogArray: [ ...this.state.awwArray ],
      isDialogOpen: true,
    });
  };

  onDialogChange = (value) => {
    this.setState({
      awwDialogArray: value
    });
  }

  onDialogClose = (save) => {
    let newState = { isDialogOpen: false };
    if (save) {
      let awwArray = [ ...this.state.awwDialogArray ];

      let days = 0.0, sum = 0.0;
      awwArray.forEach(row => {
        delete row.isSelected;
        let start = moment(row.startDate);
        let end = moment(row.endDate);
        days += end.diff(start, 'days') + 1; // Include end date.
        let wage = currencyFormatter.parse(row.wage);
        sum += wage;
      });

      let aww = sum / days * 7.0;
      let pdRate = aww * 2.0/3.0;

      // console.log('Manual AWW:', days, sum, aww);

      newState = {
        ...newState,
        inputAww: false,
        isManualAww: (save == 1) && (awwArray.length > 0),
        awwArray: awwArray,
        aww: currencyFormatter.format(aww),
        pdRate: currencyFormatter.format(pdRate)
      };
    }
    this.setState(newState, this.calculate);
  };

  onDateOfInjuryChange = (date) => {
    if (!isValidDate(date)) { return; }
    this.setState({
      doi: date
    }, this.calculate);
  }

  onWpiIndexChanged = (index) => {
    if (this.state.wpi == index) { return; }
    this.setState({
      wpi: index,
      isFull: index < 100
    }, this.calculate);
  }

  onAgeIndexChanged = (index) => {
    if (this.state.age == index) { return; }
    this.setState({
      age: index
    }, this.calculate);
  }

  onLeTableIndexChanged = (index) => {
    if (this.state.leTable == index) { return; }
    this.setState({
      leTable: index
    }, this.calculate);
  }

  onColaIndexChanged = (index) => {
    if (this.state.cola == index) { return; }
    this.setState({
      cola: index
    }, this.calculate);
  }

  onDiscountIndexChanged = (index) => {
    if (this.state.discount == index) { return; }
    this.setState({
      discount: index
    }, this.calculate);
  }

  onCompoundIndexChanged = (index) => {
    if (this.state.compound == index) { return; }
    this.setState({
      compound: index
    }, this.calculate);
  }

  onGenderChanged = (index) => {
    index = parseInt(index);
    if (this.state.gender == index) { return; }
    this.setState({
      gender: index
    }, this.calculate);
  }

  onInputAwwChanged = (checked) => {
    if (this.state.inputAww == checked || this.state.isManualAww) { return; }
    this.setState({
      inputAww: checked
    }, this.calculate);
  }

  onAwwChanged = (value) => {
    if (!this.state.inputAww) return;
    let aww = currencyFormatter.parse(value);
    // console.log(`onAwwChanged(): ${aww}`);
    this.setState({
      aww: currencyFormatter.format(aww)
    }, this.calculate);
  }

  onPdRateChanged = (value) => {
    if (!this.state.inputAww) return;
    let pdRate = currencyFormatter.parse(value);
    let aww = pdRate * 3.0/2.0;
    // console.log(`onPdRateChanged(): ${pdRate}`);
    this.setState({
      aww: currencyFormatter.format(aww)
    }, this.calculate);
  }

  // --------------------- Menu functions ---------------------
  handleMenu = (menu, submenu) => {
    // console.log(`handleMenu: menu = ${menu}, submenu = ${submenu}`);
    switch (submenu) {
      case 'save':
        this.handleMenuSave();
        break;
      case 'load':
        this.handleMenuLoad();
        break;
      case 'mail':
        this.handleMenuMail();
        break;
      case 'copy':
        this.handleMenuCopy();
        break;
      case 'clear':
        this.handleMenuClear();
    }
  }

  handleMenuSave = () => {
    let json = {
      inputAww: this.state.inputAww,
      aww: this.state.aww,

      isManualAww: this.state.isManualAww,
      awwArray: this.state.awwArray,

      doi: this.state.doi,
      wpi: this.state.wpi,
      age: this.state.age,
      leTable: this.state.leTable,
      gender: this.state.gender,

      cola: this.state.cola,
      discount: this.state.discount,
      compound: this.state.compound,
    };
    let body = JSON.stringify(json, null, 4);
    saveAsFile('present-value.json', body);
  }

  handleMenuLoad = () => {
    this.refs.fileUploader.click();
  }

  onUploadFile = (e) => {
    e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];

    let reader = new FileReader();
    reader.addEventListener('load', (e) => {
      // console.log(e.target.result);
      try {
        let hash = JSON.parse(e.target.result);
        let awwArray = hash.awwArray || [];
        awwArray.forEach(row => {
          row.startDate = new Date(row.startDate);
          row.endDate = new Date(row.endDate);
        });

        this.setState({
          inputAww: hash.inputAww,
          aww: hash.aww,

          isManualAww: hash.isManualAww,
          awwArray: awwArray,

          doi: new Date(hash.doi),
          wpi: hash.wpi,
          age: hash.age,
          leTable: hash.leTable,
          gender: hash.gender,

          cola: hash.cola,
          discount: hash.discount,
          compound: hash.compound,

          isFull: hash.wpi < 100
        }, this.calculate);
      }
      catch (e) {
        console.error(e);
      }
    });
    reader.readAsBinaryString(file);
  }

  getCopyString = () => {
    let s = `DATE OF INJURY: ${formatLongDate(this.state.doi)}
AGE AT TIME OF FIRST PAYMENT: ${this.state.age} years

GENDER: ${this.state.gender == 0 ? 'male' : 'female'}
PERMANENT DISABILITY: ${this.state.wpi}%

PV DISCOUNT RATE: ${parseFloat(this.state.discount) * 0.25}%
PV DISCOUNT RATE COMPOUNDED: ${this.compounds[this.state.compound]}
COLA INFLATION RATE: ${parseFloat(this.state.cola) * 0.25}%

`;

if (this.state.isManualAww) {
  s += `WORK PERIOD START\tWORK PERIOD END\tWAGE\n\n`;
  this.state.awwArray.forEach(row => {
    s += `${formatPrintDate(row.startDate)}\t${formatPrintDate(row.endDate)}\t${row.wage}\n`;
  });
  s += '\n';
}

s+=`AVERAGE WEEKLY WAGE: ${this.state.aww}
PD RATE: ${this.state.pdRate}
`;

    if (this.state.isFull) {
      s += `
FUTURE VALUE OF PERMANENT DISABILITY: ${currencyFormatter.format(this.state.fvOfPD)}
FUTURE VALUE OF LIFE PENSION: ${currencyFormatter.format(this.state.fvOfLP)}
TOTAL FUTURE VALUE: ${currencyFormatter.format(this.state.fvTotal)}

PRESENT VALUE OF PERMANENT DISABILITY: ${currencyFormatter.format(this.state.pvOfPD)}
PRESENT VALUE / COLA OF LIFE PENSION: ${currencyFormatter.format(this.state.pvOfLP)}
TOTAL PRESENT VALUE:  ${currencyFormatter.format(this.state.pvTotal)}
`;
    }
    else {
      s += `
FUTURE VALUE: ${currencyFormatter.format(this.state.fvOfPD)}
PRESENT VALUE / COLA: ${currencyFormatter.format(this.state.pvOfPD)}
`;
    }
    // s += "\n--------------------------------------------------------------\nCompCalc Plus: “the Complex made Simple ...”\n";
    return s;
  }

  handleMenuMail = () => {
    let s = this.getCopyString();
    sendMail('', 'Present Value / Future Value / COLA', s);
  }

  handleMenuCopy = () => {
    this.props.copyToClipboard(this.getCopyString());
  }

  handleMenuClear = () => {
    // Initial state has no body details / occupations arrays.
    this.setState(this.initialState, this.calculate);
  }

  // --------------------- Calculations ---------------------
  calculate = () => {
    if (!isValidDate(this.state.doi)) { return; }

    let percent = this.state.wpi;
    let age = this.state.age;
    let doi = this.state.doi;
    let discountRate = parseFloat(this.state.discount) * 0.25;
    let colaRate = parseFloat(this.state.cola) * 0.25;
    let compound = this.compounds[this.state.compound].toLowerCase();
    let gender = this.state.gender == 0 ? 'male' : 'female';

    let aww = this.state.inputAww || this.state.isManualAww ? currencyFormatter.parse(this.state.aww) : 0.0;
    if (aww == NaN || aww < 0)
      aww = 0;

    let leTable = this.state.leTable;

    let url = `api/v1/present_value.json?date=${formatShortDate(doi)}&disability=${percent}&age=${age}&cola=${colaRate}&discount=${discountRate}&compound=${compound}&gender=${gender}&aww=${aww}&leTable=${leTable}`;

    this.props.fetch(url, result => {
      this.showResult(result);
    }).catch(e => this.props.showError(e, 'Error obtaining present value calculations from server'));

  }

  showResult = (result) => {
    // console.log(result);
    // result: { "date":"2015-01-01T00:00:00.000+00:00", "disability":70, "age":50, "discount":0.01, "cola":0.04, "stepsPerYear":1.0,
    //   "gender":"male", "aww":0.0, "lifeExpectancyTable":2010,
    //   "minRate":160.0, "maxRate":290.0, "rate":290.0,
    //   "fvPD":125642.5, "pvPD":122235.53, "yearsPD":8.31, "fvLP":85827.91, "pvLP":110440.81, "yearsLP":21.29
    // }
    let pdRateText = result.rate <= result.minRate ? 'PD Rate (minimum)' : result.rate >= result.maxRate ? 'PD Rate (maximum)' : 'PD Rate';
    let totalFV = result.fvPD + result.fvLP;
    let totalPV = result.pvPD + result.pvLP;
    let totalYears = result.yearsPD + result.yearsLP;

    let pvOfPDText = this.state.isFull ? this.pvOfPDText : this.pvOfPDText100;
    let fvOfPDText = this.state.isFull ? this.fvOfPDText : this.fvOfPDText100;

    var newState = {
      pdRateText: pdRateText,
      pdRate: currencyFormatter.format(result.rate),
      fvOfPDText: fvOfPDText,
      pvOfPDText: pvOfPDText,

      fvOfPD: result.fvPD,
      pvOfPD: result.pvPD,
      yearsPD: result.yearsPD.toFixed(2),
    };
    if (result.disability != 100) {
      newState = {
        ...newState,
        fvOfLP: result.fvLP,
        pvOfLP: result.pvLP,
        yearsLP: result.yearsLP.toFixed(2),

        fvTotal: totalFV,
        pvTotal: totalPV,
        yearsTotal: totalYears.toFixed(2),
      };
    }
    if ((!this.state.inputAww && !this.state.isManualAww) || currencyFormatter.parse(this.state.aww) <= 0.0) {
      let maxAWW = parseFloat(result.maxRate) * 3.0 / 2.0;
      newState.aww = currencyFormatter.format(maxAWW);
    }
    this.setState(newState, this.handleMenuCopy);
  }

  // --------------------- Rendering ---------------------
  render() {
    const { classes } = this.props;

    return (
      <div style={{height: '100%'}}>
      <input type="file" id="file" ref="fileUploader" style={{display: "none"}} onChange={this.onUploadFile}/>
      <MuiPickersUtilsProvider utils={ DateFnsUtils }>
      <Grid container spacing={1} className={classes.root}>

        {/* Date of Injury */}
        <Grid item xs={3} className={classes.alignCenter}>
          <Paper className={classes.wrapContent}>
            <DatePicker
              label="Date of Injury"
              variant="outlined"
              format={'MM/dd/yyyy' }
              minDate={ this.minDOI }
              maxDate={ this.maxDOI }
              value={ this.state.doi }
              onChange={ this.onDateOfInjuryChange }
            />
          </Paper>
        </Grid>

        {/* Permanent Disability */}
        <Grid item xs={3} className={classes.alignCenter}>
          <Paper className={classes.wrapContent}>
            <FormControl>
              <FormLabel component="legend">Permanent Disability</FormLabel>
              <Select
                value={ this.state.wpi }
                onChange={ e => this.onWpiIndexChanged(e.target.value) }
                input={<Input id="wpi" name="wpi" />}
                autoWidth
              >
                { this.itemsWPI }
              </Select>
            </FormControl>
          </Paper>
        </Grid>

        {/* Age */}
        <Grid item xs={3} className={classes.alignCenter}>
          <Paper className={classes.wrapContent}>
            <FormControl>
              <FormLabel component="legend">Age at First Payment</FormLabel>
              <Select
                value={ this.state.age }
                onChange={ e => this.onAgeIndexChanged(e.target.value) }
                input={<Input id="age" name="age" />}
                autoWidth
              >
                { this.itemsAge }
              </Select>
            </FormControl>
          </Paper>
        </Grid>

        {/* Life Expectancy Table */}
        <Grid item xs={3} className={classes.alignCenter}>
          <Paper className={classes.wrapContent}>
            <FormControl>
              <FormLabel component="legend">Life Expectancy Table</FormLabel>
              <Select
                value={ this.state.leTable }
                onChange={ e => this.onLeTableIndexChanged(e.target.value) }
                input={<Input id="leTable" name="leTable" />}
                autoWidth
              >
                { this.itemsLeTable }
              </Select>
            </FormControl>
          </Paper>
        </Grid>

        {/* COLA */}
        <Grid item xs={4} className={classes.alignCenter}>
          <Paper className={classes.wrapContent}>
            <FormControl>
              <FormLabel component="legend">COLA Inflation Rate</FormLabel>
              <Select
                value={ this.state.cola }
                onChange={ e => this.onColaIndexChanged(e.target.value) }
                input={<Input id="cola" name="cola" />}
                autoWidth
              >
                { this.itemsDiscount }
              </Select>
            </FormControl>
          </Paper>
        </Grid>

        {/* PV Discount Rate */}
        <Grid item xs={4} className={classes.alignCenter}>
          <Paper className={classes.wrapContent}>
            <FormControl>
              <FormLabel component="legend">Present Value Discount Rate</FormLabel>
              <Select
                value={ this.state.discount }
                onChange={ e => this.onDiscountIndexChanged(e.target.value) }
                input={<Input id="discount" name="discount" />}
                autoWidth
              >
                { this.itemsDiscount }
              </Select>
            </FormControl>
          </Paper>
        </Grid>

        {/* PV Compound */}
        <Grid item xs={4} className={classes.alignCenter}>
          <Paper className={classes.wrapContent}>
            <FormControl>
              <FormLabel component="legend">PV Discount Rate Compounded</FormLabel>
              <Select
                value={ this.state.compound }
                onChange={ e => this.onCompoundIndexChanged(e.target.value) }
                input={<Input id="compound" name="compound" />}
                autoWidth
              >
                { this.itemsCompound }
              </Select>
            </FormControl>
          </Paper>
        </Grid>

        {/* Gender */}
        <Grid item xs={4} className={classes.alignCenter}>
          <Paper className={classes.wrapContent}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Gender</FormLabel>
              <RadioGroup
                aria-label="Increase"
                name="increase"
                className={ classes.group }
                value={ this.state.gender.toString() }
                onChange={ (e) => this.onGenderChanged(e.target.value) }
              >
                <FormControlLabel value={ "0" } control={<Radio color="primary" />} label="Male" />
                <FormControlLabel value={ "1" } control={<Radio color="primary" />} label="Female" />
              </RadioGroup>
            </FormControl>
          </Paper>
        </Grid>

        <Grid item xs={3} className={classes.alignCenter}>
          {/* Input AWW */}
          <Paper className={classes.wrapContent}>
            <FormControl margin='none' >
              <React.Fragment>
                <List dense disablePadding>
                  <ListItem button dense key='inputAww' onClick={() => this.onInputAwwChanged(!this.state.inputAww)}>
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        tabIndex={-1}
                        disableRipple
                        disabled={ this.state.isManualAww }
                        indeterminate={ this.state.isManualAww }
                        checked={ this.state.inputAww }
                        onChange={ (e) => this.onInputAwwChanged(e.target.checked) }
                        color="primary"
                        inputProps={{ 'aria-labelledby': 'AWW' }}
                      />
                    </ListItemIcon>
                    <ListItemText primary={ this.state.isManualAww ? 'Manual AWW' : 'Input AWW' } />
                    <ListItemSecondaryAction>
                      <Tooltip title="Manually input work periods and wages" aria-label="Add">
                        <IconButton
                          edge="end"
                          color={ this.state.awwArray.length > 0 ? "primary" : "inherit" }
                          aria-label="edit"
                          onClick={ this.onDialogOpen }>
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                    </ListItemSecondaryAction>
                  </ListItem>
                </List>
                <TextField
                  id="aww"
                  value={ this.state.aww }
                  onKeyPress={ e => e.key == 'Enter' && e.target.blur() }
                  onChange={ (e) => this.setState({ aww: e.target.value, inputAww: true }) }
                  onFocus={ (e) => e.target.select() }
                  onBlur={ (e) => this.onAwwChanged(e.target.value) }
                  className={ classes.textField }
                  margin="dense"
                  InputProps={{
                    readOnly: this.state.isManualAww,
                  }}
                />
              </React.Fragment>
            </FormControl>
          </Paper>
        </Grid>

        <Grid item xs={3} className={classes.alignCenter}>
          {/* PD Rate */}
          <Paper className={classes.wrapContent}>
            <FormControl>
              <React.Fragment>
                <List dense disablePadding>
                  <ListItem button dense key='inputPdRate' onClick={() => this.onInputAwwChanged(!this.state.inputAww)}>
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        tabIndex={-1}
                        disableRipple
                        disabled={ this.state.isManualAww }
                        indeterminate={ this.state.isManualAww }
                        checked={ this.state.inputAww }
                        onChange={ (e) => this.onInputAwwChanged(e.target.checked) }
                        color="primary"
                        inputProps={{ 'aria-labelledby': 'PDRate' }}
                      />
                    </ListItemIcon>
                    <ListItemText primary={ this.state.pdRateText } />
                  </ListItem>
                </List>
                <TextField
                  id="pdRate"
                  value={ this.state.pdRate }
                  onKeyPress={ e => e.key == 'Enter' && e.target.blur() }
                  onChange={ (e) => this.setState({ pdRate: e.target.value, inputAww: true }) }
                  onFocus={ (e) => e.target.select() }
                  onBlur={ (e) => this.onPdRateChanged(e.target.value) }
                  className={ classes.textField }
                  margin="dense"
                  InputProps={{
                    readOnly: this.state.isManualAww,
                  }}
                />
              </React.Fragment>
            </FormControl>
          </Paper>
        </Grid>

        {/* Future Value of Permanent Disability */}
        <Grid item xs={4} className={classes.alignCenter}>
          <Paper className={classes.wrapContent}>
            <TextField
              id="fvOfPD"
              label={ this.state.fvOfPDText }
              variant="outlined"
              value={ currencyFormatter.format(this.state.fvOfPD) }
              className={ classes.textField }
              margin="none"
              InputLabelProps={{
                shrink: true,
                className: classes.inputLabel,
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Paper>
        </Grid>

        {/* Present Value of Permanent Disability */}
        <Grid item xs={4} className={ classes.alignCenter }>
          <Paper className={ classes.wrapContent }>
            <TextField
              id="pvOfPD"
              label={ this.state.pvOfPDText }
              variant="outlined"
              value={ currencyFormatter.format(this.state.pvOfPD) }
              className={ classes.textField }
              margin="none"
              InputLabelProps={{
                shrink: true,
                className: classes.inputLabel,
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Paper>
        </Grid>

        {/* Years of PD Payments */}
        <Grid item xs={4} className={ classes.alignCenter }>
          <Paper className={ classes.wrapContent }>
            <TextField
              id="yearsOfPD"
              label="Years of PD Payments"
              variant="outlined"
              value={ this.state.yearsPD }
              className={ classes.textField }
              margin="none"
              InputLabelProps={{
                shrink: true,
                className: classes.inputLabel,
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Paper>
        </Grid>
      </Grid>


      { this.state.isFull &&
        <Grid container spacing={1} className={classes.root}>


          {/* Future Value of Life Pension */}
          <Grid item xs={4} className={classes.alignCenter}>
            <Paper className={classes.wrapContent}>
              <TextField
                id="fvOfLP"
                label="Future Value of LP"
                variant="outlined"
                value={ currencyFormatter.format(this.state.fvOfLP) }
                className={ classes.textField }
                margin="none"
                InputLabelProps={{
                  shrink: true,
                  className: classes.inputLabel,
                }}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Paper>
          </Grid>

          {/* Present Value of Life Pension */}
          <Grid item xs={4} className={ classes.alignCenter }>
            <Paper className={ classes.wrapContent }>
              <TextField
                id="pvOfLP"
                label="PV / COLA of LP"
                variant="outlined"
                value={ currencyFormatter.format(this.state.pvOfLP) }
                className={ classes.textField }
                margin="none"
                InputLabelProps={{
                  shrink: true,
                  className: classes.inputLabel,
                }}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Paper>
          </Grid>

          {/* Years of LP Payments */}
          <Grid item xs={4} className={ classes.alignCenter }>
            <Paper className={ classes.wrapContent }>
              <TextField
                id="yearsOfLP"
                label="Years of LP Payments"
                variant="outlined"
                value={ this.state.yearsLP }
                className={ classes.textField }
                margin="none"
                InputLabelProps={{
                  shrink: true,
                  className: classes.inputLabel,
                }}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Paper>
          </Grid>


          {/* Total Future Value */}
          <Grid item xs={4} className={classes.alignCenter}>
            <Paper className={classes.wrapContent}>
              <TextField
                id="totalFV"
                label="Total Future Value"
                variant="outlined"
                value={ currencyFormatter.format(this.state.fvTotal) }
                className={ classes.textField }
                margin="none"
                InputLabelProps={{
                  shrink: true,
                  className: classes.inputLabel,
                }}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Paper>
          </Grid>

          {/* Total Present Value / COLA */}
          <Grid item xs={4} className={ classes.alignCenter }>
            <Paper className={ classes.wrapContent }>
              <TextField
                id="totalPV"
                label="Total PV / COLA"
                variant="outlined"
                value={ currencyFormatter.format(this.state.pvTotal) }
                className={ classes.textField }
                margin="none"
                InputLabelProps={{
                  shrink: true,
                  className: classes.inputLabel,
                }}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Paper>
          </Grid>

          {/* Total Years of Payments */}
          <Grid item xs={4} className={ classes.alignCenter }>
            <Paper className={ classes.wrapContent }>
              <TextField
                id="totalYears"
                label="Total Years of Payments"
                variant="outlined"
                value={ this.state.yearsTotal }
                className={ classes.textField }
                margin="none"
                InputLabelProps={{
                  shrink: true,
                  className: classes.inputLabel,
                }}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Paper>
          </Grid>

        </Grid>}

        <TempDisabilityEarningsDialog
          classes={{
            paper: classes.withSpacing,
          }}
          id="dialog"
          keepMounted
          isOpen={ this.state.isDialogOpen }
          onValueChange={ this.onDialogChange }
          onClose={ this.onDialogClose }
          dateOfInjury={ this.state.doi }
          value={ this.state.awwDialogArray }
        />

      </MuiPickersUtilsProvider>
      </div>
    );
  }

};

export default withStyles(styles)(withErrorHandling(PVCalc));
